// @ts-nocheck

import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

const ResolveCname = new ReduxAsyncAction('RESOLVE_CNAME');
ResolveCname.registerRequest(function (host) {
  return dash_api
    .get('/v1/cname/resolve', {
      params: {
        host,
      },
    })
    .then(({ data }) => data);
});
export const resolveCname = ResolveCname.request;
export const RESOLVE_CNAME = ResolveCname.constants;
